module.exports = __webpack_public_path__ + "img/expand_more_black.54415fd7.svg";